import React from 'react';
import { Flex, Grid, GridItem } from '@chakra-ui/react';

import { WeekdayNamesShort } from '../../util';

function WeekdayHeader() {
  return (
    <Grid gap={2} height="40px" templateColumns="repeat(7, 1fr)">
      {WeekdayNamesShort.map(weekday => (
        <GridItem
          alignItems="center"
          as={Flex}
          justify="center"
          key={weekday}
          textStyle="bodyMd600"
          w="100%"
        >
          {weekday}
        </GridItem>
      ))}
    </Grid>
  );
}

export default WeekdayHeader;
